import React, { useState, useContext, lazy, Suspense } from "react";
import { useTranslate } from 'react-redux-multilingual';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';
import { IsAuthContext } from 'app/App';
import { pennylaneStatusColorClass } from '../Facturation/pennylaneLabels'

const PennylaneTicketModal = lazy(() => import('../Facturation/PennylaneTicketModal'));

// Sends a POS ticket to Pennylane as an invoice (shown only when the Pennylane option is active).
// status (last known transmission status, or null/undefined if never requested) colours the cloud
// at a glance: green = transmitted, orange = needs attention, blue = in progress, default = not sent yet
const PennylaneTicketBtn = ({ticketId, ticketBar, status, index, onChanged}) => {
    const t = useTranslate();
    const { authParam } = useContext(IsAuthContext);
    const [show,setShow] = useState(false)
    const moduleAdmin = authParam.modules.find(value => value.name==='admin')

    if(!moduleAdmin?.params?.pennylane?.active) return false

    const tooltip = status ? t('pennylaneStatus_'+status) : t('pennylaneTicketButton')

    return (
        <>
            <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id={`tooltip-pennylane-${index ?? ticketId}`}>{tooltip}</Tooltip>}
            >
                <span onClick={() => setShow(true)} className={'pointer '+pennylaneStatusColorClass(status)}><FontAwesomeIcon icon={faCloudUploadAlt} /></span>
            </OverlayTrigger>
            {show &&
                <Suspense fallback={false}>
                    <PennylaneTicketModal ticketId={ticketId} ticketBar={ticketBar} show={show} onHide={() => setShow(false)} onChanged={onChanged} />
                </Suspense>
            }
        </>
    )
}

export default PennylaneTicketBtn;
